<template>
  <div v-if="processData && processData.length > 0" :style="{ height, width }" style="padding: 0.1rem">
    <div class="each-model" v-for="(item, index) in processData" :key="index">
        <div class="line">
          <p v-if="item.stageText && item.stageText.length >= 4">{{ addWrapChar(item.stageText) }}</p>
          <p v-else>{{ item.stageText }}</p>
          <div class="dashed"></div>
        </div>
        <div class="content">
          <div style="margin-bottom:0.06rem">
            <span class="top">【{{ item.operatorIdText }}】{{ item.depIdText }}</span>
          </div>
          <div  class="title">
            <span v-if="item.title" :class="item.operateType == 0?'reject':'tip'">{{ item.title }}</span>
          </div>

          <div v-if="item.operateAdvice" class="process-content-row">
            <span ><i class="el-icon-chat-line-square"></i>{{ operateLabel }}：</span>
            <span>{{ item.operateAdvice }}</span>
          </div>
           <!--自定义文字内容，可多行-->
           <div v-if="item.contentRows" class="process-content-row">
            <span v-for="(row, rIndex) in item.contentRows" :key="rIndex"><i class="el-icon-chat-line-square"></i>{{ row }}</span>
          </div>
          <div class="process-content-row">
            <span><i class="el-icon-time"></i>{{ item.createTime }}</span> <span v-if="item.times" class="times" >耗时：{{ item.times }}</span>
          </div>
            <!--自定义按钮，可多个-->
          <div v-if="item.operationHandle" class="process-content-row">
            <el-button v-reClick 
                    v-for="(btn, index) in item.operationHandle"
                    :key="index"
                    type="primary" plain
                    @click="btn.handle(btn.index,btn.params)"
                    >{{ btn.label }}</el-button
                  >
          </div>
        </div>
      </div>
  </div>
  <EXNodata v-else></EXNodata>
</template>

<script>
export default {
  name: 'EXProcess',
  props: {
    height: String,
    width: String,
    processData: Array,
    operateLabel: {
       type: String,
       default: "处理意见"
    },
  },
  methods:{
    //文字超过4个自动截取2个字换行
    addWrapChar(str){
      const prefix = str.substring(0,2);
      const after = str.substring(2);
      return prefix + '\n' + after;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../styles/variables.scss';
.each-model {
  display: flex;
  margin-bottom: 0.1rem;
  .line {
    margin-right: .3rem;
    margin-top: 0.04rem;
    margin-left: 0.2rem;
    p {
      width: 0.54rem;
      height: 0.54rem;
      color: #fff;
      background: #4DA6FF;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      white-space: pre-wrap; //解决阶段中文超过2个文字的换行问题
    }
    .dashed {
      width: 0.01rem;
      height: 100%;
      margin-left: 0.26rem;
      border-right: 0.01rem solid #DCEBFD;
    }
  }
  .title{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .tip{
    border: 0;
    color: #2152C1;
    background: #DDEFF9;
    font-size: 0.15rem;
    padding: 0.02rem 0.08rem;
    margin-right: 0.06rem;
    margin-bottom: 0.06rem;
  }
  .reject{
    border: 0;
    color: #FF3B30;
    background: #f9ddde;
    font-size: 0.15rem;
    padding: 0.02rem 0.08rem;
    margin-right: 0.06rem;
    margin-bottom: 0.06rem;
  }
  .top{
    font-weight: 700;
    padding-bottom: 0.06rem;
  }
  .times{
    margin-left: 0.16rem;
  }
  .process-content-row {
    margin-bottom: 0.02rem;
    span{
      i{
        &[class^=el-icon-]{
          padding: 0.02rem;
          color: #fff;
          font-size: 0.14rem;
          background-color: #30e05e; //  52e178
          margin-right: 0.04rem;
          border-radius: 0.03rem;
        }
      }
    }
    .el-button--primary.is-plain{
      color: #2153C0;
      background-color: #dce7ff;
      border-color: #91B0F0;
      &:hover{
        color: #FFF;
        background-color: #2153C0;
        border-color: #2153C0;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/EXProcess/index.vue